<template>
    <v-list>
        <v-list-tile v-if="!numeroProtocolo" @click="propagarPrimeiroEnvioDispensaEsfinge">
            <v-list-tile-title>
                <v-icon size="15" class="mr-2">mdi-file-upload</v-icon>
                Remessa
            </v-list-tile-title>
        </v-list-tile>

        <v-list-tile
            v-else
            v-for="acao in acoesFiltradas(acoesMenu)"
            :id="acao.id"
            :key="acao.id"
            dense
        >
            <v-icon v-if="acao.icon" :size="16" class="mr-2">{{ acao.icon }}</v-icon>

            <v-list-tile-content v-if="acao.subnivel && acao.subnivel.length > 0">
                <v-menu open-on-hover right offset-x>
                    <template #activator="{ on }">
                        <div class="d-flex justify-space-between acao-nome" v-on="on">
                            {{ acao.nome }}
                            <v-icon size="28">mdi-menu-right</v-icon>
                        </div>
                    </template>

                    <v-list>
                        <v-list-tile
                            v-for="acaoSubnivel in acoesFiltradas(acao.subnivel)"
                            :id="acaoSubnivel.id"
                            :key="acaoSubnivel.id"
                            dense
                            @click="$emit(acaoSubnivel.evento)"
                        >
                            <v-icon v-if="acaoSubnivel.icon" :size="20" class="mr-2">{{ acaoSubnivel.icon }}</v-icon>
                            <v-list-tile-content class="acao-subnivel-nome"> {{ acaoSubnivel.nome }} </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-list-tile-content>
        </v-list-tile>
    </v-list>
</template>


<script>
export default {
    name: 'AcoesEnviosRemessa',
    props:['numeroProtocolo'],
    data() {
        return {
            acoesMenu: [
                {
                    id: 1,
                    nome: 'Remessa',
                    icon: 'mdi-file-upload',
                    subnivel: [
                        { id: 2, nome: 'Nova Publicação', evento: 'processarEnviarAlterarDispensaEsfinge' },
                        { id: 3, nome: 'Protocolo', evento: 'processarModalProtocoloDispensaEsfinge' },
                        { id: 4, nome: 'Cancelar', evento: 'processarCancelarDispensaEsfinge' }
                    ]
                },
            ]
        }
    },
    methods: {
        propagarPrimeiroEnvioDispensaEsfinge() {
            this.$emit('processarPrimeiroEnvioDispensaEsfinge')
        },
        acoesFiltradas(acoes) {
            return acoes
        },
    }
}
</script>

<style scoped lang="stylus">
    .acao-nome
        margin-left: 2px
        font-size: 14px
        line-height: 26px
    .acao-subnivel-nome
        font-size: 14px
</style>

